<script setup>

import { defineEmits, defineProps, onMounted, onUpdated } from "vue"

import Button from "@/components/Button.vue";
import i18n from "@/plugins/i18n";
import {useSwal} from "@/composables/useSwal";
import {useStore} from "vuex";

const {showSwal} = useSwal()

const store = useStore()

const emits = defineEmits(['callback'])

const props = defineProps({
  discussionId: {
    type: String,
    required: true,
  }
})

function deleteConversation() {
  showSwal(
      i18n.global.t('swal.chat_discussion_deleted'),
      i18n.global.t('swal.chat.chat_discussion_deleted_text')
  ).then( async (result) => {
    if (result.value) {
      store.dispatch('chat/deleteDiscussion', props.discussionId)
          .then(() => {
            window.toastr['success'](i18n.global.t('notification.chat_discussion_deleted'))
          })
          .catch(() => {

          }).finally(() => emits('callback'))
    }
  })
}

onMounted(() => {
  KTMenu.init();
})

onUpdated(() => {
  KTMenu.init();
})

</script>

<template>
  <div id="discussion_action_menu" class="mx-1">
    <button type="button"
            data-kt-menu-trigger="hover"
            data-kt-menu-placement="bottom-end"
            data-kt-menu-attach="parent"
            class="btn btn-outline-primary bg-hover-light btn-icon">
      <i class="fa fa-ellipsis-v fs-2"></i>
    </button>

    <div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-200px py-4" data-kt-menu="true">
      <div class="menu-item px-3">
        <a @click.prevent="deleteConversation" href="#" class="menu-link px-3">
          <span class="text-danger">
            <span class="me-4 fs-3 "><i class="fa fa-trash text-danger"></i></span>
            <span> Supprimer la discussion </span>
          </span>
        </a>
      </div>

    </div>
  </div>


</template>

<style scoped>

</style>